import React, { PureComponent, lazy, Suspense } from 'react';
import ContentArea from '../../afw/components/ContentArea/ContentArea';
import ContentPanel from '../../afw/components/ContentArea/ContentPanel';
import './ContentParser.css';
import { connect } from 'react-redux';
import { actionCreators as dbCreators } from '../../afw/store/db';
import { bindActionCreators } from 'redux';
import Fallback from './Fallback';
import ScrollableAnchor from '../ScrollableAnchor/ScrollableAnchor';
import { guid } from '../../afw/js/common';

class ContentParser extends PureComponent {
  constructor(props) {
    super(props);
    const {data} = props;
    this.state = {
      dataSources: {},
      data
    }
  }
  async componentDidMount(){
    const dataSources = await this.loadDataFromComponents(this.mapDataToComponents(this.props.data));
    if(dataSources) this.setState({dataSources});
  }
  loadDataFromComponents=async(components)=>{
    const {db} = this.props;
    let sources = {}
    if(Array.isArray(components)){
      for(var i = 0; i < components.length; i++){
        const table = components[i].data.datasource.table;
        if(table) sources[components[i].data.component_id] =  await db[table].load(components[i].data.datasource.loadoptions)
      }
    }
    return Object.keys(sources).length !== 0 ? sources : null;
  }
  mapDataToComponents=(data)=>{
    return data.t_component.map(o=>this.loadComponentFromPath(
      o.t_cd_component.path,
      o.component_name,
      o
    )).sort((a,b)=>a.data.order-b.data.order);
  }
  loadComponentFromPath=(path, component_name, data)=>({
    component: lazy(()=>import(`../../components/${path}.js`)), 
    component_name,
    data: data ? data : undefined
  })
  handleRenderComponent(component, data){
    const MyComponent = component;
    // CSS Fix for incorrect heights on these controls
    const styleEnum = {
      'TwitterEmbed': {height: '100%'},
      'NewsRelease': {height: '100%', display: 'flex'},
      'FeaturedVideo': {height: '100%', display: 'flex'}
    }
    let {props} = data;
    if(typeof props === 'string'){
      props = JSON.parse(props);
    }
    const {dataSources} = this.state;
    let dataSource = dataSources[data.component_id] || []; 
    const idStr = data.component_id === 0 ? guid() : data.component_id;

    return (
      <ScrollableAnchor id={`c${idStr}`} style={styleEnum[data.component_name]}>
        <MyComponent {...props} dataSource={dataSource}/>
      </ScrollableAnchor>
    )
  }
  render() {
    const {data, noMargin} = this.props;
    let {noPaper} = this.props;
    const hasChildren = data.SR_t_page_layout_LAYOUT_PARENT.length > 0;
    noPaper = hasChildren ? true : noMargin ? true : noPaper;
    return (
      <React.Fragment>
        <ContentPanel noPaper colSpan={data.colspan} rowSpan={data.rowspan} column={data.col} row={data.row} style={{padding: '0px', margin: '0px'}}>
          {
            hasChildren ? (
              <ContentArea colCount={data.colCount} rowCount={data.rowCount}>
                {data.SR_t_page_layout_LAYOUT_PARENT.map((o,i)=>{
                  return (
                    <ContentParser key={o.layout_id} data={o} index={i} />
                  )
                })}
              </ContentArea>
            ) : null
          }
          {
            this.mapDataToComponents(data).map((o,i)=>(
              <Suspense key={i} fallback={<Fallback component={o.component_name}/>}>
                {this.handleRenderComponent(o.component, o.data)}
              </Suspense> 
            ))
          }
        </ContentPanel>
      </React.Fragment>
    )
  }
}
ContentParser.defaultProps={
  noPaper: false
}
export default connect(
  state => ({db: state.db}),
  dispatch => bindActionCreators({...dbCreators}, dispatch)
)(ContentParser);